import toastr from 'toastr'
import { hasPermits } from 'directives'
import { editableText, editableRadio, editableCheckbox } from 'components/editable'
import { confirm } from 'components/modals'
import newFee from './newFee'
import { helper} from 'services'

const components = {
  newFee,
  editableText,
  editableRadio,
  editableCheckbox,
  confirm
}

const directives = {
  hasPermits
}

const computed = {
  fees () {
    return _.cloneDeep(this.$store.state.locations.active.fees);
  }
}

const methods = {
  async onEditFee (editableData, item, key) {

    await this.$store.dispatch('locations.getFees', this.$route.params.id).then(() => {
      this.db_fee_data = _.cloneDeep(this.$store.state.locations.active.fees);
    });
    item[key] = editableData.value;

    if (!this.validateValuesChanges(item)) {
      toastr.error("someone else is making changes to this page, please copy your changes, refresh and do it again.");
      editableData.stopLoading();
      editableData.close();
      return;
    }

    editableData.startLoading();
    if (key == 'calculation') {
      if (item.calculation == 'one_time') {
        item.type = 'fixed';
      }
    }
    this.$store.dispatch('locations.updateFee', {
      locId: this.$route.params.id,
      id: item.id, data: item
    }).then(() => {
      editableData.stopLoading();
      let errors;
      if (this.$store.state.locations.errors) {
        errors = this.$store.state.locations.errors.errors;
        _.forEach(errors, (error) => {
          toastr.error(error[0]);
        })
      } else {
        editableData.close();
        this.initiate_fee_data = _.cloneDeep(this.$store.state.locations.active.fees);
      }
    })
  },

  removeFee (id) {
    this.$refs.confirmDelete.confirm('Are you sure?', () => {
      this.loadings[id] = true;
      this.loadings = _.cloneDeep(this.loadings);
      this.$store.dispatch('locations.removeFee', {
        locId: this.$route.params.id,
        id
      }).then(() => {
        this.loadings[id] = false;
        let errors;
        if (this.$store.state.locations.errors) {
          errors = this.$store.state.locations.errors.errors;
          console.log('errors', errors);
          _.forEach(errors.errors, (error) => {
            toastr.error(error[0]);
          })
        } else {
          toastr.success('fee removed successfully');
        }
      });
    })
  },

  validateValuesChanges (item) {
    let db_fee_data = _.filter(this.db_fee_data, o => o.id == item.id);
    let initiate_fee_data = _.filter(this.initiate_fee_data, o => o.id == item.id);
    
    db_fee_data = db_fee_data.length ? db_fee_data[0] : [];
    initiate_fee_data = initiate_fee_data.length ? initiate_fee_data[0] : [];

    if (_.isEmpty(db_fee_data)) {
      return false;
    }

    return helper.validateChanges(this.keys, item, initiate_fee_data, db_fee_data);
  }
}

export default {
  name: 'location-fees',
  components,
  directives,
  computed,
  methods,
  data () {
    return {
      loadings: {},
      locId: this.$route.params.id,
      keys: ['name', 'associated_to', 'amount', 'description', 'calculation', 'include_in_tax'],
      initiate_fee_data: {},
      db_fee_data: {},
    }
  },

  created () {
    this.initiate_fee_data = _.cloneDeep(this.$store.state.locations.active.fees);
  },
}
